import type { StateCreator } from 'zustand'

import type { ProjectsDataSlice, ProjectsStore } from '../types'

export const createProjectsDataSlice: StateCreator<
  ProjectsStore,
  [['zustand/immer', never]],
  [],
  ProjectsDataSlice
> = () => ({
  projects: [],
  allProjects: [],
  userProjectsFetched: false,
  currentProject: null,
  isResolvingWorkspaceProject: false,
  loading: false,
  error: null,
})
